import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { merge, Observable } from 'rxjs';
import { map, scan, shareReplay } from 'rxjs/operators';
import { NamSelectedObjectService } from 'src/app/servizi/nam/nam-object-selected.service';
import { RelatedItemInterface, RelatedItemsInterface } from '../model/related-item.interface';

@Component({
  selector: 'app-related-items',
  templateUrl: './related-items.component.html',
  styleUrls: ['./related-items.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RelatedItemsComponent implements OnInit {
  relatedItemsPagination: RelatedItemsInterface = [];
  icons = { faSearch };
  filteredRelatedItems: RelatedItemsInterface = [];
  pageSize: number = 4;

  private _relatedItems: RelatedItemsInterface = [];
  @Input()
  get relatedItems(): RelatedItemsInterface {
    return this._relatedItems;
  }
  set relatedItems(relatedItems: RelatedItemsInterface) {
    this._relatedItems = (!!relatedItems && relatedItems) || [];

    this.filteredRelatedItems = this.relatedItems.map((o) => ({ ...o }));
    this.relatedItemsPagination = this.relatedItems.slice(0, this.pageSize).map((o) => ({ ...o }));
  }

  selectedObjectBackground$: Observable<unknown>;

  constructor(
    private cdr: ChangeDetectorRef,
    private namSelectedObjectService: NamSelectedObjectService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.selectedObjectBackground$ = merge(
      namSelectedObjectService.selectedObjectForEditGeometry$.pipe(map(s => ({...s, 'background': 'bg-info'}))),
      namSelectedObjectService.selectedObjectToHighlight$.pipe(map(s => ({...s, 'background': 'bg-warning'}))),
      namSelectedObjectService.deselectedObject$.pipe(map(s => ({...s, 'background': 'none'}))),
    ).pipe(
      shareReplay(1)
    )
  }

  ngOnInit(): void {}

  handleSelectRelatedObjectInfo(e: RelatedItemInterface) {
    // console.log({ e });
    this.namSelectedObjectService.selectedObjectForInfo = e;

    //Update the urn in the url without changing the route.
    //This does not trigger a reload.
    // this.router.navigate(
    //   [],
    //   {
    //     relativeTo: this.activatedRoute,
    //     queryParams: { urn: e.urn },
    //     queryParamsHandling: 'merge'
    //   });
  }

  handleSelectRelatedObjectToHighlight(e: RelatedItemInterface) {
    this.namSelectedObjectService.selectedObjectToHighlight = e;
  }

  handleSelectRelatedObjectEditGeometry(e: RelatedItemInterface) {
    this.namSelectedObjectService.selectedObjectForEditGeometry = e;
  }
  
  handleDeselectRelatedObjectGeometry(e: RelatedItemInterface) {
    this.namSelectedObjectService.deselectedObject = e;
  }

  searchData(event) {
    this.filteredRelatedItems = this.relatedItems.filter((item) =>
      item.label.toLowerCase().includes(event.target.value.toLowerCase())
    );
  }

  onTrackRelatedItemsBy(index, item: RelatedItemInterface) {
    return item.urn;
  }

  getListPagination(evt: RelatedItemsInterface): void {
    this.relatedItemsPagination =[...evt];
    this.cdr.detectChanges();
  }
}
